(function () {
  if (window.__ctQvQtyTotalPrice) return;
  window.__ctQvQtyTotalPrice = true;

  const SCOPE_SEL = '.qv-content';
  const PRICE_SEL = '.qv-product-price';
  const COMPARE_SEL = '.qv-product-compare-price';
  const QTY_INPUT_SEL = 'input.qv-quantity';
  const QTY_BTN_SEL = 'a.qv-qtity[data-multi]';
  const OPTION_SEL = 'select.option';

  function parseMoney(text) {
    const t = String(text || '').trim();
    const m = t.match(/([^\d\s.,]+)?\s*([\d.,]+)/); // symbol + number
    if (!m) return { symbol: '$', cents: 0 };

    const symbol = (m[1] && m[1].trim()) ? m[1].trim() : '$';
    let s = (m[2] || '').replace(/\s/g, '');

    const lastDot = s.lastIndexOf('.');
    const lastComma = s.lastIndexOf(',');
    const decSep = (lastDot > -1 || lastComma > -1) ? (lastDot > lastComma ? '.' : ',') : null;

    let intPart = s;
    let fracPart = '00';

    if (decSep) {
      const parts = s.split(decSep);
      fracPart = (parts.pop() || '').replace(/[^\d]/g, '');
      intPart = parts.join(decSep);
    }

    intPart = intPart.replace(/[^\d]/g, '');
    if (!intPart) intPart = '0';

    if (fracPart.length === 0) fracPart = '00';
    if (fracPart.length === 1) fracPart = fracPart + '0';
    fracPart = fracPart.slice(0, 2);

    const cents = (parseInt(intPart, 10) * 100) + parseInt(fracPart, 10);
    return { symbol, cents: Number.isFinite(cents) ? cents : 0 };
  }

  function formatMoney(symbol, cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      } catch (e) {}
    }
    return symbol + (cents / 100).toFixed(2);
  }

  function getQty(scope) {
    const input = scope.querySelector(QTY_INPUT_SEL);
    const v = input ? parseInt(input.value, 10) : 1;
    return Math.max(1, Number.isFinite(v) ? v : 1);
  }

  function setUnitFromCurrentPrice(scope, force) {
    const priceEl = scope.querySelector(PRICE_SEL);
    if (!priceEl) return;

    if (!force && priceEl.dataset.ctUnitCents) return;

    const parsed = parseMoney(priceEl.textContent);
    if (!parsed.cents) return;

    priceEl.dataset.ctUnitCents = String(parsed.cents);
    priceEl.dataset.ctSymbol = parsed.symbol;

    const compareEl = scope.querySelector(COMPARE_SEL);
    if (compareEl && compareEl.textContent && compareEl.textContent.trim()) {
      const c = parseMoney(compareEl.textContent);
      if (c.cents) compareEl.dataset.ctUnitCents = String(c.cents);
      if (c.symbol) compareEl.dataset.ctSymbol = c.symbol;
    }
  }

  function updateTotal(scope) {
    const priceEl = scope.querySelector(PRICE_SEL);
    if (!priceEl) return;

    const qty = getQty(scope);

    const unit = parseInt(priceEl.dataset.ctUnitCents || '0', 10);
    const symbol = priceEl.dataset.ctSymbol || '$';
    if (!unit) return;

    priceEl.textContent = formatMoney(symbol, unit * qty);

    const compareEl = scope.querySelector(COMPARE_SEL);
    if (compareEl && compareEl.style && compareEl.style.display !== 'none') {
      const cUnit = parseInt(compareEl.dataset.ctUnitCents || '0', 10);
      const cSym = compareEl.dataset.ctSymbol || symbol;
      if (cUnit) compareEl.textContent = formatMoney(cSym, cUnit * qty);
    }
  }

  function bind(scope) {
    if (scope.__ctBoundQvTotal) return;
    scope.__ctBoundQvTotal = true;

    setUnitFromCurrentPrice(scope, true);
    updateTotal(scope);

    scope.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest ? e.target.closest(QTY_BTN_SEL) : null;
      if (!btn) return;
      setTimeout(function () {
        setUnitFromCurrentPrice(scope, false);
        updateTotal(scope);
      }, 20);
    }, true);

    scope.addEventListener('input', function (e) {
      if (!e.target || !e.target.matches(QTY_INPUT_SEL)) return;
      setTimeout(function () {
        setUnitFromCurrentPrice(scope, false);
        updateTotal(scope);
      }, 0);
    }, true);

    scope.addEventListener('change', function (e) {
      if (!e.target) return;

      if (e.target.matches(OPTION_SEL)) {
        setTimeout(function () {
          setUnitFromCurrentPrice(scope, true);
          updateTotal(scope);
        }, 80);
      }
    }, true);
  }

  function scan() {
    document.querySelectorAll(SCOPE_SEL).forEach(function (scope) {
      if (!scope.querySelector(PRICE_SEL)) return;
      if (!scope.querySelector(QTY_INPUT_SEL)) return;
      bind(scope);
    });
  }

  document.addEventListener('DOMContentLoaded', scan);

  const mo = new MutationObserver(scan);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
